<template>
  <transition name="slide-up">
    <div v-if="message.show" class="fixed inset-0 z-[70] flex items-start justify-center pt-20 px-4">
      <div :class="message.type === 'success' ? 'bg-gradient-to-br from-green-500 via-emerald-600 to-teal-700' : 'bg-gradient-to-br from-red-500 via-rose-600 to-pink-700'" 
           class="relative text-white p-2 rounded-lg shadow-2xl max-w-md w-full backdrop-blur-xl border border-white/20">
        <button @click="$emit('close')" class="absolute top-4 right-4 text-white/70 hover:text-white transition-colors text-xl">
          <i class="fas fa-times"></i>
        </button>
        
        <div class="flex items-left space-x-1 mb-4 mt-4">
          <div class="flex-1 min-w-0">
            <p class="text-base truncate border-l-4 border-white/30 pl-2 font-medium leading-relaxed text-left">{{ message.text }}</p>
          </div>
        </div>
        
        <div v-if="message.guest" class="bg-white/10 rounded-lg p-4 backdrop-blur">
          <div class="space-y-3">
            <div class="flex items-center space-x-1">
              <i class="fas fa-user opacity-80"></i>
              <span class="font-semibold">{{ message.guest.title }} {{ message.guest.first_name || message.guest.firstName }} {{ message.guest.last_name || message.guest.lastName }}</span>
            </div>
            <div class="flex items-center space-x-1">
              <i class="fas fa-building opacity-80"></i>
              <span>{{ message.guest.company || 'Keine Firma hinterlegt' }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'MessageNotification',
  props: {
    message: {
      type: Object,
      required: true
    }
  },
  emits: ['close']
}
</script>
